import React from "react";

import styles from "./styles.module.scss";

/**
 * A user staged for creation, shown at the top of the users table so the
 * operator sees the account in its place before confirming the batch.
 *
 * It carries none of a real row's actions: the account does not exist yet, so
 * there is nothing to disable, re-role or reset. Removing it from the batch is
 * all it offers. The pending badge is the whole marking, matching how a staged
 * enable or disable reads on a row that does exist.
 */
const PendingCreateRow = ({ user, onRemove }) => (
    <tr data-testid={`user-pending-create-${user.email}`}>
        <td>
            <span className={styles.emailText}>{user.email}</span>
        </td>
        <td>{[user.firstName, user.lastName].filter(Boolean).join(" ") || "-"}</td>
        <td>{user.role || "-"}</td>
        <td>
            <span className={styles.pending}>New</span>
            <span className={styles.pendingBadge}>pending</span>
        </td>
        <td>-</td>
        <td className={styles.rowActions}>
            <button
                className={styles.deleteLink}
                data-testid={`user-unstage-create-${user.email}`}
                onClick={() => onRemove(user.stagedKey)}
            >
                Remove
            </button>
        </td>
    </tr>
);

export default PendingCreateRow;
